import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router-dom"

import "react-lazy-load-image-component/src/effects/blur.css"
import "@/styles/index.css"
import { AppProvider } from "@/providers/app-provider"
import { router } from "@/routes"

const rootElement = document.getElementById("root")

if (!rootElement) {
  throw new Error(
    "Elemento root não encontrado. Verifique se existe um elemento com id='root' no seu index.html.",
  )
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  </StrictMode>,
)
